/**
 * Public API service for data discovery endpoints on the Engine Flask API.
 * No authentication required — these are public data endpoints.
 */

const ENGINE_BASE_URL = process.env.REACT_APP_ENGINE_URL;

/**
 * Build a query string from an object, omitting null/undefined/empty values.
 */
function buildQuery(params) {
    const entries = Object.entries(params).filter(
        ([, v]) => v !== null && v !== undefined
    );
    if (entries.length === 0) return '';
    return '?' + new URLSearchParams(entries).toString();
}

/**
 * Generic fetch wrapper with error handling.
 */
async function fetchJson(endpoint) {
    const res = await fetch(`${ENGINE_BASE_URL}${endpoint}`);
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.error || `HTTP ${res.status}`);
    }
    return res.json();
}

export const dataApi = {
    /** List data sources with filters, pagination, and search. */
    getSources: (params = {}) =>
        fetchJson(`/data/sources${buildQuery(params)}`),

    /** Get a single data source by ID. */
    getSource: (id) => fetchJson(`/data/sources/${encodeURIComponent(id)}`),

    /** List data products with filters, pagination, and search. */
    getProducts: (params = {}) =>
        fetchJson(`/data/products${buildQuery(params)}`),

    /** Get a single data product by ID. */
    getProduct: (id) => fetchJson(`/data/products/${encodeURIComponent(id)}`),

    /** List organizations with filters, pagination, and search. */
    getOrganizations: (params = {}) =>
        fetchJson(`/data/organizations${buildQuery(params)}`),

    /** Get a single organization by ID. */
    getOrganization: (id) =>
        fetchJson(`/data/organizations/${encodeURIComponent(id)}`),
};

export default dataApi;
